<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      simulationLabel="KemperLima_1d0d0"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import KemperLima_1d0d0 from '@/device-products/KemperLima_1d0d0.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    simulationDevices: [
      { id: 0, component: KemperLima_1d0d0, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
